const mockGenresData = [
    {
        "id": 3,
        "name": "Alternative",
        "subgenres": [
            {
                "id": 2,
                "name": "Electronic"
            },
            {
                "id": 3,
                "name": "Gothic"
            },
            {
                "id": 4,
                "name": "Grunge"
            },
            {
                "id": 5,
                "name": "Indie Pop"
            },
            {
                "id": 6,
                "name": "Indie Rock"
            },
            {
                "id": 7,
                "name": "Industrial"
            },
            {
                "id": 8,
                "name": "New Wave"
            },
            {
                "id": 9,
                "name": "Punk"
            },
            {
                "id": 10,
                "name": "Ska"
            }
        ]
    },
    {
        "id": 5,
        "name": "Blues",
        "subgenres": [
            {
                "id": 13,
                "name": "African Blues"
            },
            {
                "id": 170,
                "name": "Blues Ballad"
            },
            {
                "id": 171,
                "name": "Boogie"
            },
            {
                "id": 172,
                "name": "Boogie-woogie"
            },
            {
                "id": 173,
                "name": "British Blues"
            },
            {
                "id": 174,
                "name": "Chicago Blues"
            },
            {
                "id": 175,
                "name": "Classic Female Blues"
            },
            {
                "id": 176,
                "name": "Country Blues"
            },
            {
                "id": 177,
                "name": "Delta Blues"
            },
            {
                "id": 178,
                "name": "Delta Blues"
            },
            {
                "id": 179,
                "name": "Detroit Blues"
            },
            {
                "id": 180,
                "name": "Dirty Blues"
            },
            {
                "id": 181,
                "name": "Electric Blues"
            },
            {
                "id": 182,
                "name": "Fife and Drum Blues"
            },
            {
                "id": 183,
                "name": "Gospel Blues"
            },
            {
                "id": 184,
                "name": "Harmonica Blues"
            },
            {
                "id": 185,
                "name": "Hill Country Blues"
            },
            {
                "id": 186,
                "name": "Hokum"
            },
            {
                "id": 187,
                "name": "Indian Blues"
            },
            {
                "id": 188,
                "name": "Jump Blues"
            },
            {
                "id": 189,
                "name": "Louisiana Blues"
            },
            {
                "id": 190,
                "name": "Memphis Blues"
            },
            {
                "id": 191,
                "name": "New Blues"
            },
            {
                "id": 192,
                "name": "New Orleans Blues"
            },
            {
                "id": 193,
                "name": "Piedmont Blues"
            },
            {
                "id": 194,
                "name": "Punk Blues"
            },
            {
                "id": 195,
                "name": "Blues Rock"
            },
            {
                "id": 196,
                "name": "Skiffle"
            },
            {
                "id": 197,
                "name": "Slide Guitar"
            },
            {
                "id": 198,
                "name": "Soul Blues"
            },
            {
                "id": 199,
                "name": "St. Louis Blues"
            },
            {
                "id": 200,
                "name": "Swamp Blues"
            },
            {
                "id": 201,
                "name": "Texas Blues"
            },
            {
                "id": 202,
                "name": "Twelve-bar Blues"
            },
            {
                "id": 203,
                "name": "West Coast Blues"
            }
        ]
    },
    {
        "id": 6,
        "name": "Classical",
        "subgenres": [
            {
                "id": 14,
                "name": "20-th Century"
            },
            {
                "id": 15,
                "name": "Avant-garde"
            },
            {
                "id": 16,
                "name": "Baroque"
            },
            {
                "id": 17,
                "name": "Chamber Music"
            },
            {
                "id": 19,
                "name": "Classical Vocal"
            },
            {
                "id": 20,
                "name": "Guitar"
            },
            {
                "id": 21,
                "name": "Keyboard"
            },
            {
                "id": 22,
                "name": "Medieval"
            },
            {
                "id": 23,
                "name": "Opera"
            },
            {
                "id": 24,
                "name": "Orchestral"
            },
            {
                "id": 25,
                "name": "Postmodern"
            },
            {
                "id": 26,
                "name": "Romantic"
            }
        ]
    },
    {
        "id": 7,
        "name": "Country",
        "subgenres": [
            {
                "id": 27,
                "name": "Americana"
            },
            {
                "id": 28,
                "name": "Bluegrass"
            },
            {
                "id": 29,
                "name": "British Folk"
            },
            {
                "id": 30,
                "name": "Compilations"
            },
            {
                "id": 31,
                "name": "Country"
            },
            {
                "id": 32,
                "name": "Folk"
            },
            {
                "id": 33,
                "name": "Folk Singer"
            },
            {
                "id": 34,
                "name": "Honky Tonk"
            },
            {
                "id": 35,
                "name": "Irish Folk"
            },
            {
                "id": 36,
                "name": "Live Country/Folk"
            },
            {
                "id": 37,
                "name": "Native American Folk"
            },
            {
                "id": 38,
                "name": "Rockabilly"
            },
            {
                "id": 39,
                "name": "Traditional Country"
            },
            {
                "id": 40,
                "name": "Traditional Folk"
            },
            {
                "id": 41,
                "name": "Western"
            }
        ]
    },
    {
        "id": 8,
        "name": "Dance",
        "subgenres": [
            {
                "id": 48,
                "name": "Dub"
            },
            {
                "id": 49,
                "name": "Dubstep"
            },
            {
                "id": 50,
                "name": "Electro House"
            },
            {
                "id": 52,
                "name": "Electronica"
            },
            {
                "id": 54,
                "name": "Glitch Hop"
            },
            {
                "id": 57,
                "name": "Hard Techno"
            },
            {
                "id": 58,
                "name": "Hardcore"
            },
            {
                "id": 60,
                "name": "House"
            },
            {
                "id": 65,
                "name": "Progressive House"
            },
            {
                "id": 67,
                "name": "Tech House"
            },
            {
                "id": 69,
                "name": "Trance"
            },
            {
                "id": 47,
                "name": "Drum & Bass"
            },
            {
                "id": 44,
                "name": "Deep House"
            },
            {
                "id": 46,
                "name": "DJ Tools"
            },
            {
                "id": 68,
                "name": "Techno"
            },
            {
                "id": 72,
                "name": "Vocal-House"
            },
            {
                "id": 42,
                "name": "Breaks / Breakbeat / UK Bass"
            },
            {
                "id": 61,
                "name": "Nu Disco / Disco"
            },
            {
                "id": 64,
                "name": "Minimal"
            },
            {
                "id": 157,
                "name": "Psy-Trance"
            },
            {
                "id": 154,
                "name": "Afro House"
            },
            {
                "id": 164,
                "name": "Indie Dance"
            },
            {
                "id": 165,
                "name": "Bass House"
            },
            {
                "id": 167,
                "name": "Hard Dance / Hardcore"
            },
            {
                "id": 168,
                "name": "Melodic House & Techno"
            },
            {
                "id": 169,
                "name": "Organic House / Downtempo"
            },
            {
                "id": 166,
                "name": "Mainstage | Big Room"
            },
            {
                "id": 204,
                "name": "Breaks / Breakbeat / UK Bass | Glitch Hop"
            },
            {
                "id": 205,
                "name": "Nu Disco / Disco | Funk / Soul"
            },
            {
                "id": 206,
                "name": "Nu Disco / Disco | Italo"
            },
            {
                "id": 158,
                "name": "Mainstage | Future House"
            },
            {
                "id": 207,
                "name": "140 / Deep Dubstep / Grime"
            },
            {
                "id": 208,
                "name": "Dance / Electro Pop"
            },
            {
                "id": 209,
                "name": "Dance / Electro Pop | Future Bass"
            },
            {
                "id": 210,
                "name": "Dance / Electro Pop | Pop"
            },
            {
                "id": 211,
                "name": "Dance / Electro Pop | Tropical House"
            },
            {
                "id": 212,
                "name": "DJ Tools | Acapellas"
            },
            {
                "id": 213,
                "name": "DJ Tools | Battle Tools"
            },
            {
                "id": 214,
                "name": "DJ Tools | Loops"
            },
            {
                "id": 215,
                "name": "Drum & Bass | Deep"
            },
            {
                "id": 216,
                "name": "Drum & Bass | Halftime"
            },
            {
                "id": 217,
                "name": "Drum & Bass | Jump Up"
            },
            {
                "id": 218,
                "name": "Drum & Bass | Jungle"
            },
            {
                "id": 219,
                "name": "Drum & Bass | Liquid"
            },
            {
                "id": 220,
                "name": "Dubstep | Bass"
            },
            {
                "id": 221,
                "name": "Dubstep | Melodic Dubstep"
            },
            {
                "id": 222,
                "name": "Electro (Classic / Detroit / Modern)"
            },
            {
                "id": 223,
                "name": "Electronica | Ambient"
            },
            {
                "id": 224,
                "name": "Funky House"
            },
            {
                "id": 225,
                "name": "Hard Dance / Hardcore | Frenchcore"
            },
            {
                "id": 226,
                "name": "Hard Dance / Hardcore | Hard House"
            },
            {
                "id": 228,
                "name": "Hard Dance / Hardcore | Hardstyle"
            },
            {
                "id": 229,
                "name": "Hard Dance / Hardcore | Terror"
            },
            {
                "id": 230,
                "name": "Hard Dance / Hardcore | UK / Happy Hardcore"
            },
            {
                "id": 231,
                "name": "Hard Dance / Hardcore | Uptempo"
            },
            {
                "id": 232,
                "name": "House | Acid"
            },
            {
                "id": 233,
                "name": "House | Soulful"
            },
            {
                "id": 234,
                "name": "Jackin House"
            },
            {
                "id": 235,
                "name": "Mainstage"
            },
            {
                "id": 236,
                "name": "Mainstage | Electro House"
            },
            {
                "id": 238,
                "name": "Mainstage | Speed House"
            },
            {
                "id": 239,
                "name": "Minimal / Deep Tech | Bounce"
            },
            {
                "id": 240,
                "name": "Minimal / Deep Tech | Deep Tech"
            },
            {
                "id": 241,
                "name": "Organic House / Downtempo | Downtempo"
            },
            {
                "id": 242,
                "name": "Psy-Trance | Full-On"
            },
            {
                "id": 245,
                "name": "Techno (Peak Time / Driving) | Driving"
            },
            {
                "id": 246,
                "name": "Techno (Peak Time / Driving) | Peak Time"
            },
            {
                "id": 247,
                "name": "Techno (Raw / Deep / Hypnotic)"
            },
            {
                "id": 248,
                "name": "Techno (Raw / Deep / Hypnotic) | Broken"
            },
            {
                "id": 249,
                "name": "Techno (Raw / Deep / Hypnotic) | Deep / Hypnotic"
            },
            {
                "id": 250,
                "name": "Techno (Raw / Deep / Hypnotic) | Dub"
            },
            {
                "id": 251,
                "name": "Techno (Raw / Deep / Hypnotic) | EBM"
            },
            {
                "id": 252,
                "name": "Techno (Raw / Deep / Hypnotic) | Raw"
            },
            {
                "id": 253,
                "name": "Trance | Tech"
            },
            {
                "id": 254,
                "name": "Trance | Uplifting"
            },
            {
                "id": 255,
                "name": "Trance | Vocal"
            },
            {
                "id": 256,
                "name": "Trap / Wave"
            },
            {
                "id": 257,
                "name": "UK Garage / Bassline"
            },
            {
                "id": 258,
                "name": "UK Garage / Bassline | Bassline"
            },
            {
                "id": 259,
                "name": "UK Garage / Bassline | UK Garage"
            },
            {
                "id": 260,
                "name": "Afro House | Afro / Latin"
            },
            {
                "id": 261,
                "name": "Amapiano"
            },
            {
                "id": 262,
                "name": "Amapiano | Gqom"
            },
            {
                "id": 263,
                "name": "Dubstep | Midtempo"
            },
            {
                "id": 264,
                "name": "Indie Dance | Dark Disco"
            },
            {
                "id": 265,
                "name": "Mainstage | Future Rave"
            },
            {
                "id": 266,
                "name": "Psy-Trance | Psychedelic"
            },
            {
                "id": 267,
                "name": "Psy-Trance | Dark & Forest"
            },
            {
                "id": 268,
                "name": "Psy-Trance | Goa Trance"
            },
            {
                "id": 269,
                "name": "Psy-Trance | Psycore & Hi-Tech"
            },
            {
                "id": 270,
                "name": "Tech House | Latin Tech"
            },
            {
                "id": 271,
                "name": "Trance | Progressive"
            },
            {
                "id": 272,
                "name": "Trance | Hard Trance"
            },
            {
                "id": 273,
                "name": "Trance (Raw / Deep / Hypnotic)"
            },
            {
                "id": 274,
                "name": "Trance (Raw / Deep / Hypnotic) | Raw Trance"
            },
            {
                "id": 275,
                "name": "Trance (Raw / Deep / Hypnotic) | Deep Trance"
            },
            {
                "id": 276,
                "name": "Trance (Raw / Deep / Hypnotic) | Hypnotic Trance"
            }
        ]
    },
    {
        "id": 9,
        "name": "Hip Hop/Rap",
        "subgenres": [
            {
                "id": 73,
                "name": "Alternative"
            },
            {
                "id": 74,
                "name": "Bass/Miami"
            },
            {
                "id": 75,
                "name": "Dj Mix"
            },
            {
                "id": 76,
                "name": "French Hip Hop"
            },
            {
                "id": 77,
                "name": "German Hip Hop"
            },
            {
                "id": 79,
                "name": "Latin"
            },
            {
                "id": 80,
                "name": "Old School"
            },
            {
                "id": 81,
                "name": "R&B"
            },
            {
                "id": 82,
                "name": "Raggaeton"
            },
            {
                "id": 83,
                "name": "Rap"
            },
            {
                "id": 84,
                "name": "Soul"
            }
        ]
    },
    {
        "id": 10,
        "name": "Jazz",
        "subgenres": [
            {
                "id": 85,
                "name": "Acid Jazz"
            },
            {
                "id": 86,
                "name": "Bebop"
            },
            {
                "id": 87,
                "name": "Big Band"
            },
            {
                "id": 88,
                "name": "Classic"
            },
            {
                "id": 89,
                "name": "Contemporary"
            },
            {
                "id": 90,
                "name": "Easy Listening"
            },
            {
                "id": 91,
                "name": "Fusion"
            },
            {
                "id": 93,
                "name": "Jazz Funk"
            },
            {
                "id": 94,
                "name": "Latin Jazz"
            },
            {
                "id": 95,
                "name": "Nu Jazz"
            },
            {
                "id": 96,
                "name": "Smooth Jazz"
            },
            {
                "id": 97,
                "name": "Swing"
            },
            {
                "id": 98,
                "name": "Traditional"
            }
        ]
    },
    {
        "id": 11,
        "name": "Latin",
        "subgenres": [
            {
                "id": 99,
                "name": "Bossa Nova"
            },
            {
                "id": 100,
                "name": "Brasil/Tropical"
            },
            {
                "id": 102,
                "name": "Pop"
            },
            {
                "id": 103,
                "name": "Rock"
            },
            {
                "id": 104,
                "name": "Salsa"
            },
            {
                "id": 105,
                "name": "Urban"
            }
        ]
    },
    {
        "id": 12,
        "name": "Pop",
        "subgenres": [
            {
                "id": 106,
                "name": "Alternative"
            },
            {
                "id": 107,
                "name": "Contemporary"
            },
            {
                "id": 108,
                "name": "Dance"
            },
            {
                "id": 109,
                "name": "Folk"
            },
            {
                "id": 110,
                "name": "French"
            },
            {
                "id": 111,
                "name": "German"
            },
            {
                "id": 112,
                "name": "Italo"
            },
            {
                "id": 113,
                "name": "Latin"
            },
            {
                "id": 115,
                "name": "R&B"
            },
            {
                "id": 116,
                "name": "Rock"
            },
            {
                "id": 117,
                "name": "Singer/Songwriter"
            },
            {
                "id": 118,
                "name": "Spanish"
            }
        ]
    },
    {
        "id": 13,
        "name": "R&B/Soul",
        "subgenres": [
            {
                "id": 119,
                "name": "Contemporary"
            },
            {
                "id": 120,
                "name": "Disco"
            },
            {
                "id": 121,
                "name": "Funk & Soul"
            },
            {
                "id": 122,
                "name": "Hip Hop"
            }
        ]
    },
    {
        "id": 14,
        "name": "Reggae",
        "subgenres": []
    },
    {
        "id": 15,
        "name": "Rock",
        "subgenres": [
            {
                "id": 125,
                "name": "Alternative"
            },
            {
                "id": 126,
                "name": "Brit-Pop"
            },
            {
                "id": 127,
                "name": "Classic"
            },
            {
                "id": 128,
                "name": "Folk"
            },
            {
                "id": 129,
                "name": "Gothic"
            },
            {
                "id": 130,
                "name": "Hard Rock"
            },
            {
                "id": 131,
                "name": "Heavy Metal"
            },
            {
                "id": 132,
                "name": "Progressive"
            },
            {
                "id": 134,
                "name": "Rock n Roll"
            },
            {
                "id": 135,
                "name": "Singer/Songwriter"
            }
        ]
    },
    {
        "id": 16,
        "name": "World",
        "subgenres": [
            {
                "id": 136,
                "name": "African"
            },
            {
                "id": 137,
                "name": "Afro Beat"
            },
            {
                "id": 138,
                "name": "Afro Pop"
            },
            {
                "id": 139,
                "name": "Asian"
            },
            {
                "id": 140,
                "name": "Australia"
            },
            {
                "id": 141,
                "name": "Brazilian"
            },
            {
                "id": 142,
                "name": "Caribbean"
            },
            {
                "id": 143,
                "name": "Celtic"
            },
            {
                "id": 144,
                "name": "European"
            },
            {
                "id": 145,
                "name": "India"
            },
            {
                "id": 146,
                "name": "Irish Traditional"
            },
            {
                "id": 147,
                "name": "Jewish"
            },
            {
                "id": 148,
                "name": "Mediterranean"
            },
            {
                "id": 149,
                "name": "Middle East"
            },
            {
                "id": 150,
                "name": "Native American"
            },
            {
                "id": 151,
                "name": "New Age"
            },
            {
                "id": 152,
                "name": "Worldbeat"
            }
        ]
    },
    {
        "id": 17,
        "name": "Folk",
        "subgenres": []
    },
    {
        "id": 18,
        "name": "Inspirational",
        "subgenres": []
    },
    {
        "id": 19,
        "name": "New Age",
        "subgenres": [
            {
                "id": 277,
                "name": "Healing"
            },
            {
                "id": 278,
                "name": "Meditation"
            },
            {
                "id": 279,
                "name": "Nature"
            },
            {
                "id": 280,
                "name": "Relaxation"
            },
            {
                "id": 281,
                "name": "Travel"
            },
            {
                "id": 282,
                "name": "Yoga"
            }
        ]
    },
    {
        "id": 20,
        "name": "Opera",
        "subgenres": []
    }
];
export default mockGenresData;
